import { useState, useCallback } from 'react';
import quarkusApi from '../api/quarkusApi';

export function useMarkNotificationRead() {
  const [isLoading, setLoading] = useState(false);

  const markAsRead = useCallback((notificationId) => {
    setLoading(true);
    return quarkusApi
      .post(`/clinic-notifications/${notificationId}/read`, null, {
        headers: { Authorization: sessionStorage.getItem('token') },
      })
      .finally(() => setLoading(false));
  }, []);

  return { markAsRead, isLoading };
}
